export { default } from './EzTextarea.vue';
